import { SimpleIconProps } from '../types';

export const IconCart = ({ className }: SimpleIconProps) => (
  <svg
    className={className}
    fill="none"
    height="16"
    role="img"
    viewBox="0 0 17 16"
    width="17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.49984 10.5H15.1665L16.8332 2.16667H3.6415L3.49984 0.5H0.166504V1.33333H2.73317L3.42484 9.66667H1.82484V13H3.72484C3.58317 13.25 3.4915 13.525 3.4915 13.8333C3.4915 14.75 4.2415 15.5 5.15817 15.5C6.07484 15.5 6.82484 14.75 6.82484 13.8333C6.82484 13.525 6.73317 13.25 6.5915 13H10.3832C10.2415 13.25 10.1498 13.525 10.1498 13.8333C10.1498 14.75 10.8998 15.5 11.8165 15.5C12.7332 15.5 13.4832 14.75 13.4832 13.8333C13.4832 13.525 13.3915 13.25 13.2498 13H15.1498V12.1667H2.6665V10.5H3.49984Z"
      fill="#101820"
    />
  </svg>
);
